import { track } from '../utils/analytics'

// Landing-page CTA funnel. The landing page is plain ERB (no Vue), so we attach
// one delegated click listener that turns clicks on any [data-cta-destination]
// link into a single clean event. This collapses the page's many differently
// worded "start"/"try"/"sign in" links into one funnel step tagged by where it
// goes (signup / demo / signin) and where it sits (nav / hero / final / footer),
// which autocapture can't do cleanly because each link has different text.
let bound = false

export function mountLanding() {
  // Only the landing page carries these data attributes; bail elsewhere.
  if (bound || !document.querySelector('[data-cta-destination]')) return
  bound = true

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cta-destination]')
    if (!link) return
    track('landing_cta_clicked', {
      destination: link.dataset.ctaDestination,           // signup | demo | signin
      location: link.dataset.ctaLocation || 'unknown',    // nav | hero | hero_subtext | final | footer
    })
  })

  // Hero "hear it spoken" button: plays the real pre-generated Southern audio
  // for the mock's word. Hearing the product is the pitch, so it's also tracked
  // as a micro-conversion.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-play-audio]')
    if (!button) return
    try {
      new Audio(button.dataset.playAudio).play().catch(() => {})
      track('landing_hero_audio_played', {})
    } catch (_e) {
      // Missing/blocked audio should never break the page.
    }
  })
}
